<template>
  <div>
    <el-card>
      <!-- 评论列表 -->
      <el-table
          :data="orderList.slice((queryInfo.pagenum-1)*queryInfo.pagesize,queryInfo.pagenum*queryInfo.pagesize)"
          border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="课程标题" prop="title" width="270px"></el-table-column>
        <el-table-column label="课程介绍" prop="info"  width="245px"></el-table-column>
        <el-table-column label="课程类型" prop="type" width="120px"></el-table-column>
        <el-table-column label="下单用户" prop="userName" width="150px"></el-table-column>
        <el-table-column label="下单时间" prop="orderTime" width="250px"></el-table-column>
        <el-table-column label="价格（元）" prop="price" width="120px"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[5, 10, 15]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import {Message, MessageBox} from "element-ui";

export default {
  name: "Order",
  data() {
    return {
      orderList: '',
      queryInfo: {
        query: '',
        pagenum: 1, // 当前页数
        pagesize: 5 // 当前每页显示的条数
      },
      total: 0
    }
  },
  created() {
    this.getOrder()
  },
  methods: {
    // 查询所有订单
    async getOrder() {
      const {data: res} = await this.$http.post('/users/getOrder')
      this.orderList = res.data
      this.total = res.data.length
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
    },
    // 监听页码值改变的事件
    handleCurrentChange(pageNum) {
      this.queryInfo.pagenum = pageNum
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
